/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
// utils
import { APIStringtoDate } from '../../../../utils/date';
import { fetchProductDataLastUpdated } from '../../../../state/thunks/product';
import { getDevices } from '../../../../utils/filterhelpers';
// material
import { Page, Content, InContentMessage} from '@insticator/insticator-ui';
import Header from '../../../../material/structure/header/header';
import PageHeader from '../../../../material/structure/pageheader/pageheader';
import PageContent from '../../../../material/structure/pagecontent/pagecontent';
import GlobalFilter from '../../../../material/globalfilter/globalfilter';
// styles
import injectSheet from 'react-jss';
import styles from './trendingnowv2analytics_styles';
import PageViewReport from './pageviewreport/pageviewreport';
import { fetchAvgInViewReport, fetchGeneratedPageViews, fetchPageViewReport, fetchTopArticlesReport, fetchTotalClicksReport, fetchTotalEmbedLoadsReport, fetchTrendingNowV2Config } from 'state/thunks/trendingnowv2';
import TotalClicksReport from './totalclicksreport/totalclicksreports';
import Space from 'material/space/space';
import TopArticlesReport from './toparticlesreport/toparticlesreport';
import InviewEmbedLoadsReport from './inviewembedloadsreport/inviewembedloadsreport';




/* ========== ~~~~~~~~~~ COMMENTING - ANALYTICS PAGE ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => {
    // state
    const { accountUUID, siteUUID } = useSelector((state) => state.session);
    const { sites, dateRange, devices, compareTo, countries } = useSelector((state) => state.app.filters);
    const { lastUpdated } = useSelector(state => state.trendingNowV2);
    const [selectedInterval, setSelectedInterval] = useState('daily');
    const [selectedMetric, selectMetric] = useState('page_loads')
    // actions
    const dispatch = useDispatch();

    // request reports on division load
    useEffect(() => {
        sendReportRequests()
    }, [sites, devices, compareTo, countries, selectedInterval]);

    // request top articles on change of selected metric
    useEffect(() => {
        getTopArticlesReport()
    }, [selectedMetric])

    const sendReportRequests = () => {
        getPageViewReport()
        getTotalClicksReport()
        getAvgInViewReport()
        getTotalEmbedLoadsReport()
        getGeneratedPageViewsReport()
        getTopArticlesReport()
        getProductDataLastUpdated()
    }

    const getProductDataLastUpdated = () => dispatch(fetchProductDataLastUpdated('TRENDING_NOW'));
    
    const getPageViewReport = () => dispatch(fetchPageViewReport({requestData: getRequestData()}))

    const getTotalClicksReport = () => dispatch(fetchTotalClicksReport({requestData: getRequestData()}))

    const getAvgInViewReport = () => dispatch(fetchAvgInViewReport({requestData: getRequestData()}))

    const getTotalEmbedLoadsReport = () => dispatch(fetchTotalEmbedLoadsReport({requestData: getRequestData()}))

    const getGeneratedPageViewsReport = () => dispatch(fetchGeneratedPageViews({requestData: getRequestData()}))

    const getTopArticlesReport = () => dispatch(
        fetchTopArticlesReport({
            requestData: topArticlesRequestData
        }
    ));


    const getRequestData = () => ({
        accountUUID,
        sites: sites,
        startDate: dateRange.from,
        endDate: dateRange.to,
        devices: getDevices(devices, 'trending'),
        granularity: selectedInterval.toUpperCase(),
        comparisonType: compareTo,
        countries: countries.length === 250 ? [] : countries
    });

    const topArticlesRequestData = {
        ...getRequestData(),
        metricType: selectedMetric,
        isAscendingOrder: false
    }

    const getBannerText = useCallback(() => {
        // if start date is before June 21st 2021
        const june21stDate = new Date(2021, 5, 21)
         if (dateRange.from && APIStringtoDate(dateRange.from) < june21stDate){
             return 'There is no commenting data prior to June 21st, 2021';
         }
         return null;
    }, [dateRange]);

    return (
        <Page name={'trendingnowv2analyticspage'} klass={`${props.classes.trendingnowv2analyticspage}`} >
            <Header>
                <GlobalFilter onFilterApply={sendReportRequests}/>
            </Header>
            <Content>
                <InContentMessage/>
                <PageHeader
                    lastUpdatedTimestamp={lastUpdated}
                    title={'Trending Now'}
                    subtitle={'Analytics'}
                    dataTip={true}
                    bannerText={getBannerText()} />
                <PageContent>
                    <Space gap={24} direction={'column'}>
                    <TotalClicksReport selectedInterval={selectedInterval} setSelectedInterval={setSelectedInterval} />
                    <InviewEmbedLoadsReport selectedInterval={selectedInterval} setSelectedInterval={setSelectedInterval}  />
                    <TopArticlesReport 
                        selectMetric={selectMetric} 
                        selectedMetric={selectedMetric} 
                        requestData={topArticlesRequestData}
                        selectedInterval={selectedInterval} 
                        setSelectedInterval={setSelectedInterval}  
                    />
                    </Space>
                </PageContent>
            </Content>
        </Page>
    );
});
